import { Common } from '@thecvlb/design-system/lib/src';

import AdvantageItem from 'features/AdvantageItem';

import { parseTime } from 'utils/helpers';

interface FirstAppointmentInfoProps {
  advantages?: string[];
  providerName?: string;
  startTime?: string;
}

const FirstAppointmentInfo: React.FC<FirstAppointmentInfoProps> = ({
  startTime,
  providerName = 'Your provider',
  advantages = []
}) => {
  return (
    <div className="rounded-2xl shadow">
      <div className="flex gap-4 rounded-t-2xl bg-primary-100 p-6 text-mXl text-primary-700">
        <div className="flex size-12 flex-none rounded-full bg-primary-200">
          <Common.Icon className="m-auto size-8 text-primary" name="doctor" />
        </div>
        <div className="flex flex-col gap-1">
          <h2 className="text-mLg font-bold md:text-xl">Appointment</h2>
          {startTime && (
            <span className="text-mSm md:text-base">
              {providerName} • {parseTime(startTime ?? '')}
            </span>
          )}
        </div>
      </div>
      {!!advantages.length && (
        <div className="flex flex-col gap-2 p-4 text-mSm">
          {advantages.map((a) => (
            <AdvantageItem advantage={a} className="max-md:text-mSm" key={a} />
          ))}
        </div>
      )}
    </div>
  );
};

export default FirstAppointmentInfo;
